import { CloseCircle } from 'iconsax-react';
import { useTiclickTableContext } from './context/ticlick-table-context-hook';

export function TiclickTableSelectionIndicator() {
  const { table } = useTiclickTableContext();
  const selectedRowsNumber = table.getSelectedRowModel().rows.length;

  if (!selectedRowsNumber) return null;

  return (
    <span className='px-3 py-2.5 text-gray-800 h-full flex text-sm gap-2 rounded-xl items-center border border-pale-border'>
      <CloseCircle
        className='cursor-pointer'
        size={16}
        onClick={() => table.resetRowSelection()}
      />
      Selected ({selectedRowsNumber})
    </span>
  );
}
